// plop_marker:layouts_import
import SimpoCustomerSuccess from "./simpo-customer-success/index.js";
export default {
    // plop_marker:layouts_add_layout
    SimpoCustomerSuccess
};
